<template>
  <div class="con">
    <div class="text item" v-loading="loading">
      <network-info :network-info="networkInfo"></network-info>
      <div class="setting">{{ $t("lang.wire.functionConfiguration") }}</div>
      <el-divider content-position="left">{{
        $t("lang.wire.normalSetting")
      }}</el-divider>
      <div class="Table-Con">
        <el-form ref="ruleForm" :model="data" label-width="300px" class="demo-ruleForm">
          <el-form-item :label="`${$t('lang.ConfigSetting.Protocol')}：`" prop="name">
            <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.proto" size="mini"
              class="Form-Input-Width">
              <el-option v-for="item in protocol" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="data.proto == 'static'">
            <!-- ipv4地址 -->
            <el-form-item :label="`${$t('lang.ConfigSetting.IPv4address')}：`" prop="ipaddr"
              v-if="compareVersionV(deviceSoftwareVer, 'v2.5.220820') >= 0">
              <el-form :model="data" :rules="rules" ref="ipv4">
                <el-form-item v-for="i in data.ipaddr.length" prop="ipaddr">
                  <el-input size="mini" class="Form-Input-Width" v-model="data.ipaddr[i - 1]"></el-input>
                  <el-button size="mini" type="danger" style="margin-left: 10px;" v-if="i != data.ipaddr.length"
                    icon="el-icon-minus" @click="removeClick(i)"></el-button>
                  <el-button size="mini" type="primary" style="margin-left: 10px;" v-if="i == data.ipaddr.length"
                    @click="addIPv4" icon="el-icon-plus"></el-button>
                </el-form-item>
              </el-form>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.IPv4address')}：`" prop="ipaddr" v-else>
              <el-input size="mini" class="Form-Input-Width" v-model="data.ipaddr" @change="ErrorIpaddr(data.ipaddr)">
              </el-input>
              <p class="error-mess" v-if="error.ipaddr">
                {{ $t("lang.ConfigSetting.Pleasecheck") }}
              </p>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.IPv4netmask')}：`" prop="region"
              v-if="compareVersionV(deviceSoftwareVer, 'v2.5.220820') == -1">
              <select-input :SelectArr="IPv4protocol" :SelectValue="data.netmask" @GetSelectValue="GetSelectValue">
              </select-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.UsecustomDNSservers')}：`" prop="region">
              <add-input :dns="data.dns" @GetAddInput="GetAddInput"></add-input>
            </el-form-item>
          </div>
          <el-form-item :label="`${$t('lang.wire.hostname')}：`" prop="region" v-if="data.proto == 'dhcp'">
            <el-input size="mini" class="Form-Input-Width" v-model="data.hostname" placeholder="M2M"></el-input>
          </el-form-item>
          <!-- 当选择的协议与原来的不同时切换 -->
          <!-- <el-form-item :label="`${$t('lang.wire.confirmChange')}：`" v-if="WatchData.proto !== data.proto">
              <el-button size="mini" type="danger">{{$t('lang.wire.changeProtocol')}}</el-button>
            </el-form-item> -->
        </el-form>
      </div>
      <el-divider content-position="left" v-if="data.proto == 'static'">{{
        $t("lang.wire.DHCPServer")
      }}</el-divider>
      <div class="Table-Con" v-if="data.proto == 'static'">
        <el-form ref="ruleForm" :model="dhcpData" label-width="200px" class="demo-ruleForm">
          <el-form-item class="Item" :label="`${$t('lang.wire.ignoreInterface')}：`" prop="name">
            <el-checkbox v-model="dhcpData.ignore"></el-checkbox>
            <p class="tips">{{ $t("lang.wire.ignoreTips") }}</p>
          </el-form-item>
          <div v-if="!dhcpData.ignore">
            <el-form-item class="Item" :label="`${$t('lang.wire.start')}：`" prop="ipaddr">
              <el-input size="mini" class="Form-Input-Width" v-model="dhcpData.start"
                @change="ErrorIpaddr(data.ipaddr)">
              </el-input>
              <p class="tips">{{ $t("lang.wire.startTips") }}</p>
            </el-form-item>
            <el-form-item class="Item" :label="`${$t('lang.wire.customerNum')}：`" prop="region">
              <el-input size="mini" class="Form-Input-Width" v-model="dhcpData.limit"
                @change="ErrorIpaddr(data.ipaddr)">
              </el-input>
              <p class="tips">{{ $t("lang.wire.customerNumTips") }}</p>
            </el-form-item>
            <el-form-item class="Item" :label="`${$t('lang.wire.leaseTerm')}：`" prop="region">
              <el-input size="mini" class="Form-Input-Width" v-model="dhcpData.leasetime"
                @change="ErrorIpaddr(data.ipaddr)">
              </el-input>
              <p class="tips">{{ $t("lang.wire.leaseTermTips") }}</p>
            </el-form-item>
            <el-form-item class="Item" :label="`${$t('lang.wire.DHCPOptions')}：`" prop="region">
              <div v-for="(item, index) in dhcpData.dhcpLists" :key="index">
                <div style="display: inline">
                  <el-input v-model="dhcpData.dhcpLists[index]" class="Form-Input-Width" size="mini"></el-input>
                </div>
                <div style="display: inline">
                  <el-button v-if="index === dhcpData.dhcpLists.length - 1" style="margin-left: 15px;" size="mini"
                    type="primary" @click="addDHCP">
                    +
                  </el-button>
                  <el-button v-else style="margin-left: 15px;" size="mini" type="danger" @click="deleteDHCP(index)">
                    ×
                  </el-button>
                </div>
              </div>
              <p class="tips">{{ $t("lang.wire.DHCPOptionsTips") }}</p>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-button type="danger" size="mini" @click="updateConfig" class="Config-Buttom">
        {{ $t("lang.ConfigSetting.SaveApply") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import SelectInput from "../../../SelectInput/index";
import AddInput from "../../../AddInput/index";
import networkInfo from "../../../networkInfo/index";
import {
  updateConfig,
  listConfig,
  getNetworkInfo,
} from "@/api/configurationlist";
import { cloneDeep, isEqual } from "lodash";
import { compareVersion } from "@/utils/Date";
export default {
  props: ["deviceDid", "deviceSn", "deviceSoftwareVer"],
  data() {
    var ipv4 = (rule, value, callback) => {
      let rxp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\/[\d]|[\d][\d]$/;
      for (let i = 0; i < value.length; i++) {
        if (rxp.test(value[i])) {
        } else {
          return callback(new Error("ipv4地址格式错误"));
        }
      }
      callback();
    };
    return {
      protocol: [
        { label: this.$t("lang.ConfigSetting.Staticaddress"), value: "static" },
        { label: this.$t("lang.wire.DHCP"), value: "dhcp" },
        { label: "PPPOE", value: "pppoe" },
      ],
      protocolVlue: "proto",
      //IPv4子网掩码下拉数组
      IPv4protocol: [
        { label: "255.255.255.0", value: "255.255.255.0" },
        { label: "255.255.0.0", value: "255.255.0.0" },
        { label: "255.0.0.0", value: "255.0.0.0" },
        { label: this.$t("lang.ConfigSetting.custom"), value: "自定义" },
      ],
      IPv4protocolValue: "255.255.255.0",
      //记录原始记录表单内容，比较是否有内容被修改
      WatchData: {
        proto: "",
        ipaddr: "",
        netmask: "",
        macaddr: "",
        dns: "",
        mtu: "",
        metric: "",
      },
      data: {
        ipaddr: [],
      },
      dhcpData: {
        dhcpLists: [],
      },
      copyDHCP: {},
      //获取父组件传过来的值
      PropsData: null,
      loading: true,
      // 网络接口基本信息
      networkInfo: {},
      //验证
      error: {
        ipaddr: false,
      },
      timer: null,
      rules: {
        ipaddr: [{ validator: ipv4, trigger: "blur" }],
      },
    };
  },
  components: {
    SelectInput,
    AddInput,
    networkInfo,
  },
  activated() {
    this.fetchNetworkInfo();
    this.timer = setInterval(() => {
      this.fetchNetworkInfo();
    }, 10000);
  },
  deactivated() {
    clearInterval(this.timer);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    compareVersionV(v1, v2) {
      return compareVersion(v1, v2)
    },
    //接收SelectInput的改变传过来的值
    GetSelectValue(props) {
      this.data.netmask = props;
    },
    //接收AddInput的改变传过来的值
    GetAddInput(props) {
      this.data.dns = props;
    },
    // 获取lan和DHCP信息
    getConfig() {
      this.loading = true;
      clearInterval(this.timer);
      // if (compareVersion(this.deviceSoftwareVer, "v2.5.220820") >= 0) {
      if (compareVersion(this.deviceSoftwareVer, "v2.5.220820") >= 0) {
        listConfig(this.deviceSn, this.deviceDid, [
          {
            section: "lan",
            config: "network",
            lists: [
              {
                list: "ipaddr",
              },
            ],
            options: [
              { option: "proto" },
              { option: "ipaddr" },
              { option: "netmask" },
              { option: "dns" },
              { option: "macaddr" },
              { option: "mtu" },
              { option: "metric" },
              { option: "hostname" },
            ],
          },
          {
            section: "lan",
            config: "dhcp",
            options: [
              { option: "ignore" },
              { option: "start" },
              { option: "limit" },
              { option: "leasetime" },
            ],
            lists: [{ list: "dhcp_option" }],
          },
        ])
          .then((res) => {
            res.data.data.mess.forEach((item, index) => {
              if (item.config === "network") {
                this.data = item.s_objects[0].options;
                if (item.s_objects[0].lists.ipaddr.length == 0) {
                  this.$set(this.data, "ipaddr", [""]);
                } else {
                  this.$set(
                    this.data,
                    "ipaddr",
                    item.s_objects[0].lists.ipaddr.sort()
                  );
                }
              } else if (item.config === "dhcp") {
                this.dhcpData = item.s_objects[0].options;
                this.dhcpData.ignore = this.dhcpData.ignore == 1 ? true : false;
                this.$set(
                  this.dhcpData,
                  "dhcpLists",
                  item.s_objects[0].lists.dhcp_option
                );
                if (this.dhcpData.dhcpLists.length === 0) {
                  this.$set(this.dhcpData, "dhcpLists", [""]);
                }
              }
            });
            this.copyDHCP = cloneDeep(this.dhcpData);
            this.WatchData = cloneDeep(this.data);
            this.fetchNetworkInfo();
            this.timer = setInterval(() => {
              this.fetchNetworkInfo();
            }, 10000);
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: this.$t("lang.request.timeout"),
              type: "warning",
            });
          });
      } else {
        listConfig(this.deviceSn, this.deviceDid, [
          {
            section: "lan",
            config: "network",
            options: [
              { option: "proto" },
              { option: "ipaddr" },
              { option: "netmask" },
              { option: "dns" },
              { option: "macaddr" },
              { option: "mtu" },
              { option: "metric" },
              { option: "hostname" },
            ],
          },
          {
            section: "lan",
            config: "dhcp",
            options: [
              { option: "ignore" },
              { option: "start" },
              { option: "limit" },
              { option: "leasetime" },
            ],
            lists: [{ list: "dhcp_option" }],
          },
        ])
          .then((res) => {
            res.data.data.mess.forEach((item, index) => {
              if (item.config === "network") {
                this.data = item.s_objects[0].options;
              } else if (item.config === "dhcp") {
                this.dhcpData = item.s_objects[0].options;
                this.dhcpData.ignore = this.dhcpData.ignore == 1 ? true : false;
                this.$set(
                  this.dhcpData,
                  "dhcpLists",
                  item.s_objects[0].lists.dhcp_option
                );
                if (this.dhcpData.dhcpLists.length === 0) {
                  this.dhcpData.dhcpLists.push("");
                }
              }
            });
            this.copyDHCP = cloneDeep(this.dhcpData);
            this.WatchData = cloneDeep(this.data);
            this.fetchNetworkInfo();
            this.timer = setInterval(() => {
              this.fetchNetworkInfo();
            }, 10000);
            this.loading = false;
          })
          .catch((err) => {
            this.$message({
              message: this.$t("lang.request.timeout"),
              type: "warning",
            });
          });
      }
    },
    // 获取lan接口基本信息
    fetchNetworkInfo() {
      getNetworkInfo(this.deviceDid, this.deviceSn, ["lan"]).then((res) => {
        this.networkInfo = res.data.data.mess.lan;
      });
    },
    //提交修改
    updateConfig() {
      if (this.error.ipaddr) {
        return;
      }
      this.loading = true;
      if (compareVersion(this.deviceSoftwareVer, "v2.5.220820") >= 0) {
        this.$refs["ipv4"].validate((v) => {
          if (v) {
            if (Object.keys(this.data).length > 0) {
              // 当有内容被修改才提交
              if (!isEqual(this.WatchData, this.data)) {
                clearInterval(this.timer);
                //提交修改
                if (compareVersion(this.deviceSoftwareVer, "v2.5.220820") >= 0) {
                  let ipaddr = this.data.ipaddr;
                  updateConfig(this.deviceSn, this.deviceDid, [
                    {
                      section: "lan",
                      config: "network",
                      action: 0,
                      index: [0],
                      server: "network",
                      lists: {
                        ipaddr,
                      },
                      options: {
                        ...this.data,
                        ipaddr: undefined
                      },
                    },
                  ])
                    .then((res) => {
                      if (res.data.data.mess === 0) {
                        this.$message({
                          showClose: true,
                          message: this.$t(
                            "lang.ConfigSetting.Successfulconfiguration"
                          ),
                          type: "success",
                        });
                        this.getConfig();
                      } else {
                        this.$message({
                          showClose: true,
                          message: this.$t(
                            "lang.ConfigSetting.Configurationerror"
                          ),
                          type: "warning",
                        });
                        return;
                      }
                    })
                    .catch((err) => {
                      console.log("请求超时");
                      console.log(err);
                    }).finally(() => {
                      this.loading = false;
                    });
                } else {
                  updateConfig(this.deviceSn, this.deviceDid, [
                    {
                      section: "lan",
                      config: "network",
                      action: 0,
                      index: [0],
                      server: "network",
                      options: {
                        ...this.data,
                      },
                    },
                  ])
                    .then((res) => {
                      if (res.data.data.mess === 0) {
                        this.$message({
                          showClose: true,
                          message: this.$t(
                            "lang.ConfigSetting.Successfulconfiguration"
                          ),
                          type: "success",
                        });
                        this.getConfig();
                      } else {
                        this.$message({
                          showClose: true,
                          message: this.$t(
                            "lang.ConfigSetting.Configurationerror"
                          ),
                          type: "warning",
                        });
                        return;
                      }
                    })
                    .catch((err) => {
                      console.log("请求超时");
                      console.log(err);
                    }).finally(() => {
                      this.loading = false;
                    });
                }
              }
              // DHCP信息有被修改
              if (!isEqual(this.dhcpData, this.copyDHCP)) {
                // 最传的数据对象
                let submitDHCP = {};
                // 因为DHCP输入框默认有一个，所以数组会存在值为空字符的元素，需要过滤
                let handleHDCP = cloneDeep(this.dhcpData);
                // dhcpData对象中的dhcpLists数组不作为options对象传过去
                this.$delete(handleHDCP, "dhcpLists");
                let list = [];
                // 过滤数组中的空字符
                this.dhcpData.dhcpLists.forEach((item, index) => {
                  if (item) {
                    list.push(item);
                  }
                });
                if (handleHDCP.ignore == 1) {
                  handleHDCP.ignore = "1";
                  submitDHCP = {
                    section: "lan",
                    config: "dhcp",
                    action: 0,
                    index: [0],
                    server: "dhcp",
                    options: {
                      ignore: handleHDCP.ignore,
                      limit: "",
                      leasetime: "",
                      start: "",
                    },
                    lists: {
                      dhcp_option: [],
                    },
                  };
                } else {
                  handleHDCP.ignore = "";
                  submitDHCP = {
                    section: "lan",
                    config: "dhcp",
                    action: 0,
                    index: [0],
                    server: "dnsmasq",
                    options: {
                      ...handleHDCP,
                    },
                    lists: {
                      dhcp_option: list,
                    },
                  };
                }
                //提交修改
                updateConfig(this.deviceSn, this.deviceDid, [submitDHCP])
                  .then((res) => {
                    if (res.data.data.mess === 0) {
                      this.$message({
                        showClose: true,
                        message: this.$t(
                          "lang.ConfigSetting.Successfulconfiguration"
                        ),
                        type: "success",
                      });
                      this.getConfig();
                      // this.fetchNetworkInfo()
                    } else {
                      this.$message({
                        showClose: true,
                        message: this.$t(
                          "lang.ConfigSetting.Configurationerror"
                        ),
                        type: "warning",
                      });
                      return;
                    }
                  })
                  .catch((err) => {
                    console.log("请求超时");
                    console.log(err);
                  }).finally(() => {
                    this.loading = false;
                  });
              }
              if (
                isEqual(this.dhcpData, this.copyDHCP) &&
                isEqual(this.WatchData, this.data)
              ) {
                this.$message({
                  showClose: true,
                  message: this.$t("lang.ConfigSetting.Nochangesmade"),
                  type: "warning",
                });
                return;
              }
            }
          } else {
            this.$message({
              type: "warning",
              message: "ipv4地址格式错误",
            });
            return false;
          }
        });
      } else {
        if (Object.keys(this.data).length > 0) {
          // 当有内容被修改才提交
          if (!isEqual(this.WatchData, this.data)) {
            clearInterval(this.timer);
            //提交修改
            if (compareVersion(this.deviceSoftwareVer, "v2.5.220820") >= 0) {
              let ipaddr = this.data.ipaddr;
              delete this.data.ipaddr;
              updateConfig(this.deviceSn, this.deviceDid, [
                {
                  section: "lan",
                  config: "network",
                  action: 0,
                  index: [0],
                  server: "network",
                  lists: {
                    ipaddr,
                  },
                  options: {
                    ...this.data,
                  },
                },
              ])
                .then((res) => {
                  if (res.data.data.mess === 0) {
                    this.$message({
                      showClose: true,
                      message: this.$t(
                        "lang.ConfigSetting.Successfulconfiguration"
                      ),
                      type: "success",
                    });
                    this.getConfig();
                  } else {
                    this.$message({
                      showClose: true,
                      message: this.$t("lang.ConfigSetting.Configurationerror"),
                      type: "warning",
                    });
                    return;
                  }
                })
                .catch((err) => {
                  console.log("请求超时");
                  console.log(err);
                });
            } else {
              updateConfig(this.deviceSn, this.deviceDid, [
                {
                  section: "lan",
                  config: "network",
                  action: 0,
                  index: [0],
                  server: "network",
                  options: {
                    ...this.data,
                  },
                },
              ])
                .then((res) => {
                  if (res.data.data.mess === 0) {
                    this.$message({
                      showClose: true,
                      message: this.$t(
                        "lang.ConfigSetting.Successfulconfiguration"
                      ),
                      type: "success",
                    });
                    this.getConfig();
                  } else {
                    this.$message({
                      showClose: true,
                      message: this.$t("lang.ConfigSetting.Configurationerror"),
                      type: "warning",
                    });
                    return;
                  }
                })
                .catch((err) => {
                  console.log("请求超时");
                  console.log(err);
                });
            }
          }
          // DHCP信息有被修改
          if (!isEqual(this.dhcpData, this.copyDHCP)) {
            // 最传的数据对象
            let submitDHCP = {};
            // 因为DHCP输入框默认有一个，所以数组会存在值为空字符的元素，需要过滤
            let handleHDCP = cloneDeep(this.dhcpData);
            // dhcpData对象中的dhcpLists数组不作为options对象传过去
            this.$delete(handleHDCP, "dhcpLists");
            let list = [];
            // 过滤数组中的空字符
            this.dhcpData.dhcpLists.forEach((item, index) => {
              if (item) {
                list.push(item);
              }
            });
            if (handleHDCP.ignore == 1) {
              handleHDCP.ignore = "1";
              submitDHCP = {
                section: "lan",
                config: "dhcp",
                action: 0,
                index: [0],
                server: "dhcp",
                options: {
                  ignore: handleHDCP.ignore,
                  limit: "",
                  leasetime: "",
                  start: "",
                },
                lists: {
                  dhcp_option: [],
                },
              };
            } else {
              handleHDCP.ignore = "";
              submitDHCP = {
                section: "lan",
                config: "dhcp",
                action: 0,
                index: [0],
                server: "dnsmasq",
                options: {
                  ...handleHDCP,
                },
                lists: {
                  dhcp_option: list,
                },
              };
            }
            //提交修改
            updateConfig(this.deviceSn, this.deviceDid, [submitDHCP])
              .then((res) => {
                if (res.data.data.mess === 0) {
                  this.$message({
                    showClose: true,
                    message: this.$t(
                      "lang.ConfigSetting.Successfulconfiguration"
                    ),
                    type: "success",
                  });
                  this.getConfig();
                  // this.fetchNetworkInfo()
                } else {
                  this.$message({
                    showClose: true,
                    message: this.$t("lang.ConfigSetting.Configurationerror"),
                    type: "warning",
                  });
                  return;
                }
              })
              .catch((err) => {
                console.log("请求超时");
                console.log(err);
              });
          }
          if (
            isEqual(this.dhcpData, this.copyDHCP) &&
            isEqual(this.WatchData, this.data)
          ) {
            this.$message({
              showClose: true,
              message: this.$t("lang.ConfigSetting.Nochangesmade"),
              type: "warning",
            });
            return;
          }
        }
      }
    },
    //ipv4验证
    ErrorIpaddr(props) {
      if (deviceSoftwareVer >= 'v2.5.220820') return
      let test = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      let retu = false;
      if (!test.test(props)) {
        this.error.ipaddr = true;
        retu = true;
      }
      if (!props) {
        this.error.ipaddr = false;
        retu = false;
      }
      if (!retu) {
        this.error.ipaddr = false;
      }
    },
    // 点击增加DHCP
    addDHCP() {
      this.dhcpData.dhcpLists.push("");
    },
    // 删除DHCP
    deleteDHCP(index) {
      this.dhcpData.dhcpLists.splice(index, 1);
    },
    removeClick(e) {
      console.log( this.data.ipaddr);
      
      this.data.ipaddr = this.data.ipaddr.filter((v, index) => index != e - 1);
    },
    addIPv4() {
      this.data.ipaddr.push("");
    },
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler(newValue, oldValue) {
        this.getConfig();
      },
    },
  },
};
</script>
<style scoped>
.tips {
  color: rgb(168, 164, 164);
}

.Item {
  margin-bottom: 0px;
  line-height: 20px;
}
</style>
<style src="../../../common.css" scoped></style>
